import { render, staticRenderFns } from "./Coches.vue?vue&type=template&id=66d83c83&"
import script from "./Coches.vue?vue&type=script&lang=js&"
export * from "./Coches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports